export default __webpack_public_path__ + "static/media/extra_out_d5.fc556b18.svg";